export default __webpack_public_path__ + "static/media/photo--lg--17.3d8b4690.jpg";